import { useState } from "react";
import MedicationLiquidIcon from '@mui/icons-material/MedicationLiquid';
import CodeIcon from '@mui/icons-material/Code';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export default function Steps() {
    const steps = [
        {
            id: 1,
            title: "Start Your Application",
            desc: "Enter your mobile number and basic details to begin the online loan application process and check your eligibility.",
            icon: <CodeIcon />,
            image: "/heroImg.png",
        },
        {
            id: 2,
            title: "Complete Digital Verification",
            desc: "Upload the required KYC and income documents, including PAN card, Aadhaar card, and salary-related details for verification.",
            icon: <DomainVerificationIcon />,
            image: "/no-money.png",
        },
        {
            id: 3,
            title: "Receive Loan Disbursal",
            desc: "After successful verification and approval, the loan amount is disbursed directly to your registered bank account, subject to lender evaluation and bank processing timelines.",
            icon: <AccountBalanceIcon />,
            image: "/introImg.png",
        },
    ];
    const [activeStep, setActiveStep] = useState(0);
    return (
        <div className="py-20 bg-white px-6">
            <div className="max-w-7xl mx-auto ">
                <div className="mb-10">
                <p className="ms-text-secondary uppercase font-semibold text-lg mb-2">
                    Simple Process
                </p>

                <h3 className="text-2xl sm:text-3xl lg:text-3xl font-bold leading-snug">
                    Complete Your Loan Application in a Few Easy Steps
                </h3>
                <p className='py-2 text-gray-500 text-sm sm:text-base leading-8'>B4Salary is designed to make the online loan application journey more organised and easier to follow for salaried professionals.
                    
                </p>
            </div>
            </div>
            
            <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
             
                {/* LEFT SIDE */}
                <div className="relative">

                    {/* vertical line */}
                    <div className="absolute left-5 top-0 h-full w-[2px] bg-gray-200"></div>

                    <div className="space-y-12">
                        {steps.map((step, index) => (
                            <div
                                key={step.id}
                                onMouseEnter={() => setActiveStep(index)}
                                onClick={() => setActiveStep(index)}
                                className="flex gap-6 cursor-pointer group"
                            >

                                {/* ICON */}
                                <div className="relative z-10">
                                    <div
                                        className={`w-12 h-12 flex items-center justify-center rounded-xl shadow-md transition-all
                      ${activeStep === index
                                                ? "bg-orange-500 text-white scale-110"
                                                : "bg-blue-900 text-white group-hover:scale-105"
                                            }`}
                                    >
                                        {step.icon}
                                    </div>
                                </div>

                                {/* TEXT */}
                                <div>
                                    <p className="text-xs text-gray-400 uppercase">
                                        Step 0{step.id}
                                    </p>

                                    <h3
                                        className={`text-lg font-semibold transition ${activeStep === index
                                            ? "text-orange-500"
                                            : "text-gray-800"
                                            }`}
                                    >
                                        {step.title}
                                    </h3>

                                    <p className="text-gray-500 text-sm mt-1">
                                        {step.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* RIGHT SIDE (Dynamic Image) */}
                {/* <div className="relative">
                    <div className="rounded-2xl border p-4 shadow-lg">
                        <img
                            key={activeStep} // important for animation
                            src={steps[activeStep].image}
                            alt="step preview"
                            className="rounded-xl w-full h-[400px] object-cover transition-all duration-500"
                        />
                    </div>
                </div> */}
            </div>
        </div>
    )
}
